import { render, staticRenderFns } from "./BbeeProductosServiciosBS.vue?vue&type=template&id=1eefbc8f"
import script from "./BbeeProductosServiciosBS.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosBS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports